import React from 'react';
import './cartSummary.css';
import CartSummary, {CartCheckout} from './cartSummary';
import { InvoiceRequest } from './invoiceRequest';

export default function CartStep({config, onSubmit = () => {}, isSubmitting}) {
    const {cart_summary, cart_checkout, invoice_request} = config?.cart_step ?? {};
    const [invoiceFormToSubmit, setInvoiceFormToSubmit] = React.useState(null);

    const _onSubmit = React.useCallback(() => {
        if (invoiceFormToSubmit !== null) {
            onSubmit({
                data: {
                    invoice: invoiceFormToSubmit,
                },
            });
        } else {
            onSubmit();
        }
    }, [onSubmit, invoiceFormToSubmit]);

    return (
        <div className='neo-cart-step'>
            <CartSummary config={cart_summary} />
            {invoice_request && <InvoiceRequest config={invoice_request} setInvoiceFormToSubmit={setInvoiceFormToSubmit}/>}
            <CartCheckout config={cart_checkout} onSubmit={_onSubmit} isSubmitting={isSubmitting} />
        </div>
    )
}